import type { NavItem } from '../model/types';

export const navigationItems: NavItem[] = [
  { label: '서비스', href: '#services' },
  { label: '기술', href: '#technology' },
  { label: 'FAQ', href: '#faq' },
];
